import React from 'react';
import { connect } from 'redux-zero/react';
import { injectIntl } from 'react-intl';

import OurValuesPageService from './our-values.service.js';
import { actions } from '../../shared/store.js';
import NotImplemented from '../../components/not-implemented/page-not-implemented.js';
import BulletList from '../../components/bullet-list/bullet-list.js';
import ScrollToTop from '../../shared/utils.js';
import Seo from '../../infrastructure/seo.js';

import './our-values.scss';

class OurValuesPage extends React.Component {
	static prefetchData = async language => OurValuesPageService.getOurValuesData(language);

	state = {
		hasError: false,
	};

	componentDidMount() {
		const { ourValues, setLoading } = this.props;

		ScrollToTop();
		if (ourValues.length === 0) {
			this.fetchData();
		} else {
			setLoading(false);
		}
	}

	componentDidUpdate(prevProps) {
		const { language } = this.props;

		ScrollToTop();
		if (prevProps.language.value !== language.value) {
			this.fetchData();
		}
	}

	fetchData() {
		const { language, setOurValues, setLoading } = this.props;

		setLoading(true);
		OurValuesPage.prefetchData(language.value)
			.then((res) => {
				setOurValues(res);
				setLoading(false);
			})
			.catch(() => {
				this.setState({ hasError: true });
				setLoading(false);
			});
	}

	render() {
		const { ourValues, intl: { formatMessage }, addresses, phones, generalData } = this.props;
		const { hasError } = this.state;

		if (hasError) {
			return <NotImplemented title="Our values" />;
		}

		return (
			<div className="our-values-page">
				<Seo
					title={formatMessage({ id: 'navigation.about.ourValues' })}
					description={formatMessage({ id: 'navigation.about.ourValues' })}
					microdata={`{
									"@context": "https://schema.org",
									"@graph": [
										{
											"@type": "AboutPage",
											"name": "${formatMessage({ id: 'navigation.about.ourValues' })}"
										},
										{
											"@type": "WebApplication",
											"name": "Inocrowd",
											"url": "${process.env.REACT_APP_WEBSITE_ENDPOINT}",
											"applicationCategory": "BusinessApplication",
											"operatingSystem": "Windows, Linux, OSX, iOS, Android",
											"sameAs": [
												"${process.env.REACT_APP_PLATFORM_ENDPOINT}",
												"https://www.facebook.com/InoCrowd/",
												"https://www.linkedin.com/company/inocrowd",
												"https://twitter.com/InoCrowd",
												"https://www.instagram.com/inocrowd",
												"https://www.youtube.com/channel/UC8JotJA9Txz_6NQXWuEwdvQ"
											],
											"provider": {
												"@type": "Organization",
												"name": "Inocrowd",
												${addresses.length > 0 && `
													"address":  "${addresses[0].description.replace(/\n/g, ' ')}",
												`}
												${phones.length > 0 && `
													"contactPoint": {
														"@type": "ContactPoint",
														"telephone": "${phones[0].phoneNumber}",
														"contactType": "customer service"
													},
													"telephone": "${phones[0].phoneNumber}",
												`}
												${generalData && generalData.logo ? `
													"logo": "${process.env.REACT_APP_API_ENDPOINT}${generalData.logo.path}"
												` : ''}
											}
										},
										{
											"@type": "BreadcrumbList",
											"itemListElement": [
												{
													"@type": "ListItem",
													"name": "Inocrowd",
													"position": 1,
													"item": "${process.env.REACT_APP_WEBSITE_ENDPOINT}"
												},
												{
													"@type": "ListItem",
													"name": "${formatMessage({ id: 'navigation.about.ourValues' })}",
													"position": 2,
													"item": "${process.env.REACT_APP_WEBSITE_ENDPOINT}/about/our-values"
												}
											]
										}
									]
								}`}
				/>
				{ourValues && <BulletList data={ourValues} />}
			</div>
		);
	}
}

const mapToProps = ({ language, ourValues, addresses, phones, generalData }) => ({
	language,
	ourValues,
	addresses,
	phones,
	generalData,
});

export default connect(
	mapToProps,
	actions,
)(injectIntl(OurValuesPage));

export { OurValuesPage };
